// Stricter regex for email validation
const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

// Regex for finding emails in text (strict)
const EMAIL_EXTRACT_REGEX =
  /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+/g;

// Regex for finding email-like strings (loose)
const EMAIL_LIKE_REGEX = /\S+@\S+/g;

export const cleanupEmail = (email: string): string => {
  // Remove spaces and special characters from the beginning and end
  return email.replace(/^[,;\s]+|[,;\s]+$/g, '').trim();
};

export const normalizeEmail = (email: string): string => {
  // Convert email to lowercase and remove extra spaces
  return cleanupEmail(email).toLowerCase();
};

export const isValidEmail = (email: string): boolean => {
  const cleanEmail = cleanupEmail(email);
  return EMAIL_REGEX.test(cleanEmail);
};

export const isDuplicateEmail = (email: string, existingEmails: string[]): boolean => {
  const normalizedNew = normalizeEmail(email);
  return existingEmails.some((existing) => normalizeEmail(existing) === normalizedNew);
};

export const extractEmails = (text: string, validateEmails = true): string[] => {
  // Split text by delimiters and search for emails in each part
  const parts = text.split(/[,;\n\t]+/);

  const emails = new Set<string>();
  const normalizedEmails = new Set<string>();

  parts.forEach((part) => {
    // Use appropriate regex based on validation mode
    const regex = validateEmails ? EMAIL_EXTRACT_REGEX : EMAIL_LIKE_REGEX;

    // Search for emails in text part
    const matches = part.match(regex);
    if (matches) {
      matches.forEach((email) => {
        const cleanEmail = cleanupEmail(email);
        const normalizedEmail = normalizeEmail(cleanEmail);
        // Check for duplicates using normalized value
        if ((!validateEmails || isValidEmail(cleanEmail)) && !normalizedEmails.has(normalizedEmail)) {
          emails.add(cleanEmail);
          normalizedEmails.add(normalizedEmail);
        }
      });
    }
  });

  return Array.from(emails);
};
